import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type { AudienceAge } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/modules/leads-search-filters/constants";
import type FindAudienceAgeFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/AudienceAgeFilter/AudienceAgeFilter";

import { TRANSLATION_PREFIX } from "./const";

const AudienceAgeFilterResult = ({
    value,
    isExpanded,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindAudienceAgeFilter>): ReactElement | null => {
    const handleRemove = (id: AudienceAge) => {
        const updatedValues = value?.filter((v: AudienceAge) => v !== id);

        onFilterValueRemove?.(updatedValues);
        onFilterUpdate(updatedValues);
    };

    const chipItems = value?.map(
        (item: string): ChipItem => ({
            id: item,
            text: translate(`${TRANSLATION_PREFIX}.${item}`),
            chipStatus: onGetLifecycleStatus?.(item),
        }),
    );

    if (!chipItems?.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemove}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default AudienceAgeFilterResult;
